import TagManager from "react-gtm-module";

const useGoogleTagManager = () => {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TM_ID!
  };

  if (
    process.env.NODE_ENV !== "development" &&
    window.location.hostname === process.env.REACT_APP_ENABLE_GTM
  ) {
    TagManager.initialize(tagManagerArgs);
  }
};

export default useGoogleTagManager;
